// extracted by mini-css-extract-plugin
export default {"contentBlock":"dvIm0","form":"rSki4","inputs":"pjfl8","dynamicInput":"lrcUF","checkbox":"eEXsf","box":"MWwgz","label":"NwPhu"};